module.exports = __webpack_public_path__ + "static/img/youshi.e1f49a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/app/youshi.png
// module id = 8iz3
// module chunks = 69